import React from "react";

const jobListings = [
  { title: "Accounts Payable Clerk", date: "03/07/2025", location: "Georgia" },
  { title: "Warehouse Associate(s)", date: "02/13/2025", location: "Dubai" },
  { title: "Senior R&D Software Developer", date: "12/02/2024", location: "Spain" },
  { title: "Senior Web Developer", date: "12/02/2024", location: "ICE Haus" },
  { title: "Sales Representative Spanish Speaker", date: "10/02/2024", location: "Spain" },
  { title: "Software Customer Support Specialist", date: "09/17/2024", location: "Remotely" },
];

// 🎯 Reusable Filter Component
const Filters = () => (
  <div className="d-flex justify-content-center gap-2 my-3">
    <input type="text" className="form-control w-25 bg-light text-dark border-secondary" placeholder="Search jobs..." />
    <select className="form-select w-25 bg-light text-dark border-secondary">
      <option>All Departments</option>
    </select>
    <select className="form-select w-25 bg-light text-dark border-secondary">
      <option>All Locations</option>
    </select>
  </div>
);

// 🎯 Reusable Job Table Component
const JobTable = ({ jobs }) => (
  <table className="table table-light table-hover text-dark">
    <thead className="table-secondary">
      <tr>
        <th>Job, Post Date</th>
        <th>Location</th>
      </tr>
    </thead>
    <tbody>
      {jobs.map(({ title, date, location }, index) => (
        <tr key={index}>
          <td>
            <button className="text-primary text-decoration-none border-0 bg-transparent p-0">
              {title}
            </button>
            <br />
            <small className="text-muted">{date}</small>
          </td>
          <td>{location}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

// 🎯 Call-To-Action Section
const CTASection = () => (
  <div className="text-center mt-4">
    <h6 className="fw-bold text-dark">Not Finding What You're Looking For?</h6>
    <p className="text-secondary">Share your information, and we will contact you if new opportunities become available.</p>
    <button className="btn btn-outline-dark">Share Your Information</button>
  </div>
);

const Careers = () => {
  return (
    <div id="careers" className="container py-5">
      <div className="p-4 bg-light shadow-sm rounded border">
      <h2 className="text-center fw-bold text-dark">Careers</h2>

        <h5 className="fw-bold text-center text-dark">{jobListings.length} Job Opportunities</h5>

        <Filters />
        <JobTable jobs={jobListings} />
        <CTASection />

        <p className="mt-3 text-center small text-secondary">
          Powered by <strong>Paylocity</strong> | 
          <button className="text-primary text-decoration-none border-0 bg-transparent p-0">
            Privacy Policy
          </button> 
          | Payroll & HR Software
        </p>
      </div>
    </div>
  );
};

export default Careers;